import { defineChain } from 'viem';

export const chain = defineChain({
  id: 7840026,
  name: 'ENERGY CHAIN',
  nativeCurrency: { decimals: 18, name: 'KILOWATTCOIN', symbol: 'KW' },
  rpcUrls: { default: { http: ['https://rpc.kilowattcoin.ru'] } },
  contracts: {
    multicall3: { address: '0xcA11bde05977b3631167028862bE2a173976CA11', blockCreated: 0 },
  },
  blockTime: 4000,
  blockExplorers: {
    default: { name: 'ENERGY CHAIN Explorer', url: 'https://explorer.kilowattcoin.ru' },
  },
});
